export default __webpack_public_path__ + "static/media/greenhouse.5eb67622.jpg";